import { render, staticRenderFns } from "./DynamicElementsDragItems.vue?vue&type=template&id=3c7cee59"
import script from "./DynamicElementsDragItems.vue?vue&type=script&lang=js"
export * from "./DynamicElementsDragItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports